import { fetchUserSMSThunk } from '../../redux/thunks/sms';
import ImageClass from '../../assets';
import { IntegrationType } from '../../params/redux/integration';
import { remindThemThunk } from '../../redux/thunks/client';
import SMSDetailComponent from './detail';
import { toast } from 'react-toastify';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { fetchClientIntegrationsThunk, fetchIntegrationsThunk } from '../../redux/thunks/integration';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

const SMSComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const { currentUser } = useSelector((state: RootState) => state.app);
    const [isConnected, setIsConnected] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchIntegrations = async () => {
            try {
                setIsLoading(true);
                // if (location.pathname.includes('/client') && currentUser?.role === 'client') {
                //     await dispatch(fetchClientIntegrationsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                //     // await dispatch(fetchUserIntegrationThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                // } else
                let response: IntegrationType[] | undefined = [];
                if (location.pathname.includes('/client') && (currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager')) {
                    response = await dispatch(fetchClientIntegrationsThunk(id ? parseInt(id as string, 10) : 0)).unwrap() as IntegrationType[] | undefined;
                } else {
                    response = await dispatch(fetchIntegrationsThunk()).unwrap() as IntegrationType[] | undefined;
                }
                if (response?.includes('twilio')) {
                    setIsConnected(true);
                    await dispatch(fetchUserSMSThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                }
            } catch (e) {
                setIsConnected(false);
            } finally {
                setIsLoading(false);
            }
        };
        fetchIntegrations();
    }, [id, currentUser?.role]);

    const handleButtonClick = async () => {
        try {
            if (location.pathname.includes('/client') && (currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager')) {
                await dispatch(remindThemThunk({ type: 'Twilio', client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
                toast.success('Reminder sent successfully!');
            } else {
                navigate('/app/integrations');
            }
        } catch (e) {
            //
        }
    };

    if (isLoading) {
        return <Box minHeight="60vh" display="flex" flexDirection="column" gap={2} alignItems="center" justifyContent="center">
            <CircularProgress />
            <Typography variant="subtitle1">Loading...</Typography>
        </Box>;
    } else if (!isConnected) {
        return (<Box minHeight="60vh">
            <Box height="100%" display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center">
                <img src={ImageClass.noEmail} alt="Email Placeholder" height="300px" />
                {location.pathname.includes('/client') && (currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager')
                    ? <Typography variant="subtitle1" color="textSecondary" align="center">Your customer doesn&apos;t have Twilio connected yet. Click<br /> the button below to request customer to complete Integration of <br /> Twilio.</Typography>
                    : <Typography variant="subtitle1" color="textSecondary" align="center">Your twilio account is not connected yet. Click<br /> the button below to complete Integration of <br /> Twilio.</Typography>}
                <Button variant="contained" onClick={handleButtonClick}>{location.pathname.includes('/client') && (currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager') ? 'Remind them' : 'Integrations'}</Button>
            </Box>
        </Box>);
    } else if (isConnected) {
        return <SMSDetailComponent />;
    }
    return <></>;
};

export default SMSComponent;